/** cSpell:words registriaqa */

/**
 * @description
 * This file contains the base URLs for the Registria redirect for each environment.
 *
 * @example
 * const registriaUrl = registriaHosts[environment];
 * console.log(registriaUrl); // Output: 'registria.com' for production, 'registriaqa.com' for qa, development, and sandbox
 */
export const registriaHosts = {
  production: 'registria.com',
  qa: 'registriaqa.com',
  development: 'registriaqa.com',
  sandbox: 'registriaqa.com',
} as Record<'production' | 'qa' | 'development' | 'sandbox', string>;
